<template>
  <div class="breadcrumb">
    <span class="list-label" >已选</span><span style="height: 2vw;line-height: 2vw;margin-right: 0.8vw;">：</span>
    <div v-for="(item,index) in router" style="display: flex;flex-wrap: nowrap;margin-top: 0.25vw;height: 1.5vw;line-height: 1.5vw; ">
      <div @click="$emit('clearSearch',index)" :disabled="item.disable" style="font-size: 0.7vw;color: white;background-color: #5eb2f7;border-radius: 1vw; min-width: 4vw;text-align: center;cursor: pointer">
        <span :class="{'text':item.name.length<=2}" style="display: inline-block;margin-left: 0.5vw;margin-right: 0.5vw">
          {{item.name}}
        </span>
      </div>
      <span v-if="index<router.length-1" style="margin-left: 0.3vw;margin-right: 0.3vw"> <i class="el-icon-arrow-right"></i> </span>
    </div>

  </div>
</template>

<script>
export default {
  name: 'breadCrumb',
  props:{
    router:{
      type:Array,
      default:null
    }
  }
}
</script>

<style scoped>
.breadcrumb{
  display: flex;
  flex-wrap: nowrap;
  font-family: test;
  font-size: 0.7vw;
  height: 2vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.list-label {
  height: 2vw;
  line-height: 2vw;
  margin-left: 0vw;
  margin-right: 0vw;
  display: inline-block;
  text-align: justify;
  vertical-align: top;
  font-size: 0.7vw;
  min-width: 2vw;
}
.list-label::after{
  width: 100%;
  display: inline-block;
  content: "";
}
.text{
  font-size: 0.7vw;
  color: white;
  background-color: #5eb2f7;
  border-radius: 1.5vw;
  cursor: pointer;
  height: 1.5vw;
  line-height: 1.5vw;
  margin-left: 0vw;
  margin-right: 0vw;
  display: inline-block;
  text-align: justify;
  vertical-align: top;
  min-width: 1.8vw;
}
.text::after{
  width: 100%;
  display: inline-block;
  content: "";
}
</style>
